import IconButton, {IconButtonProps} from '@mui/material/IconButton';
import {keyframes, styled} from '@mui/material/styles';
import React from 'react';

// Define the blink animation
const blink = keyframes`
  0%, 100% { opacity: 1; }
  50% { opacity: 0.5; }
`;

// Styled component that handles animation
const BlinkingIconButton = styled(IconButton, {
    shouldForwardProp: prop => prop !== '$blink', // Ensure $blink is not forwarded to the DOM
})<{$blink: boolean}>(({$blink}) => ({
    animation: $blink ? `${blink} 1s infinite` : 'none',
}));

interface AppBlinkingIconButtonProps extends IconButtonProps {
    shouldBlink: boolean;
}

// The AppBlinkingIconButton component
export const AppBlinkingIconButton: React.FC<AppBlinkingIconButtonProps> = ({shouldBlink, children, ...rest}) => {
    return (
        // Pass only the necessary props to the styled component
        <BlinkingIconButton {...rest} $blink={shouldBlink}>
            {children}
        </BlinkingIconButton>
    );
};

export default AppBlinkingIconButton;
